import { BsMetaUtil, getPtTokenTermEnd, isPtToken } from "@bridgesplit/abf-react";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";
import { formatDate } from "@bridgesplit/utils";

export function formatTokenName(token: TokenListMetadata | undefined): string {
    const name = BsMetaUtil.getName(token);

    if (!isPtToken(token)) {
        return name;
    }

    // Format PT token dates using getPtTokenTermEnd and formatDate
    const maturityDate = getPtTokenTermEnd(token);
    if (!maturityDate) {
        return name;
    }

    const symbol = BsMetaUtil.getSymbol(token);

    return `${symbol} (${formatDate(maturityDate, "date", { alwaysShowYear: true })})`;
}
